const groupAttrProps = {
  非素达标率: "fsdb",
  非素业绩: "fs",
  素金达标率: "sjdb",
  素金业绩: "sj",
  整体业绩: "salesNum",
  转换业绩: "zhyj",
  "钻石/非素": "zsfs",
  钻石达标率: "zsdb",
  钻石销售件数: "zsSalesNum",
  钻石业绩: "zs",
};

export default groupAttrProps;
